import Lottie from 'lottie-react';
import React, { useContext } from 'react';
import quize from '../assets/quize.json';
import { BooksContext } from '../Root/Root';
import Book from './Book';



const Home = () => {
    const Books = useContext(BooksContext)
    const { data } = Books;
    return (
        <div className="container mx-auto p-10">
            <div className='px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-24'>
                <div className='flex flex-col items-center justify-between lg:flex-row'>
                    <div className='mb-10 lg:max-w-lg  lg:pr-5 lg:mb-0'>
                        <div className='max-w-xl mb-6 lg:mt-8'>
                            <div>
                                <p className='inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-yellow-400'>
                                    Quize
                                </p>
                            </div>
                            <h2 className='max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none'>
                                Reade More<br className='hidden md:block' /> And gain More{' '}
                                <span className='inline-block text-blue-400'>Test yourself</span>
                            </h2>
                            <p className='text-base text-gray-700 md:text-lg'>
                                Quizzes encourage pupils' self awareness of progress and self assessment. By taking quizzes, pupils get instant feedback on their responses. And this can help them identify areas they need to develop themselves and highlight progress for them to be proud of
                            </p>
                        </div>
                    </div>
                    <div className='relative lg:w-1/2 '>
                        <div className='w-full lg:w-full lg:ml-auto h-96'>
                            <Lottie animationData={quize} loop={true} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="">
                    <h2 className='text-2xl text-center'>Quizes</h2>
                </div>
                <div className=" grid md:grid-cols-2 lg:grid-cols-4 gap-3 p-10">
                    {
                        data.map(book => <Book
                            key={book.id}
                            book={book}
                        ></Book>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Home;